/**
 * Availability Section for Assistant Profile
 * Allows selection of general availability
 */
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Calendar } from "lucide-react";
import { AVAILABILITY_OPTIONS } from "@/lib/profileOptions";

export default function AvailabilitySection({ generalAvailability, setGeneralAvailability }) {
  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-6">
        <Calendar className="w-5 h-5 inline mr-2" />
        Availability
      </h2>
      <div className="space-y-4">
        <Label className="text-sm text-white/60 uppercase tracking-wider">General Availability</Label>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {AVAILABILITY_OPTIONS.map((opt) => (
            <div 
              key={opt.value}
              className={`flex items-center gap-3 p-4 bg-white/[0.05] border rounded-sm cursor-pointer transition-all ${
                generalAvailability === opt.value ? "border-white/40 bg-white/5" : "border-white/10"
              }`}
              onClick={() => setGeneralAvailability(opt.value)}
              data-testid={`availability-${opt.value}`}
            >
              <div className={`w-4 h-4 rounded-full border-2 ${
                generalAvailability === opt.value ? "border-white bg-white" : "border-white/40"
              }`} />
              <span className="font-medium">{opt.label}</span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
